import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import { MdDatepickerModule } from '@angular/material';

import { OfferExpectation } from '../../interfaces/offer.interface';

import { OfferModalComponent } from '../offer-modal/offer-modal.component';

@Component({
	selector: 'app-promotion-modal',
	templateUrl: './promotion-modal.component.html',
	styleUrls: ['./promotion-modal.component.css']
})
export class PromotionModalComponent implements OnInit {
	@ViewChild('promotionModal') public promotionModal: ModalDirective;

	public emptyExpectation: OfferExpectation = { arrival: null, departure: null, adult: null, child: null, baby: null};

	constructor( ) { }

	ngOnInit() { }

	public show(): void {
		this.promotionModal.show();
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/promotion-modal/promotion-modal.component.ts